import React, { useState } from 'react';
import { X, Smartphone } from 'lucide-react';
import { usePWA } from '@/contexts/PWAContext';

/**
 * Banner de topo para utilizadores móveis que ainda não instalaram a PWA.
 * Aparece só em mobile (CSS md:hidden) e desaparece após fechar (localStorage).
 * Android: chama install() directo → 1 clique.
 * iOS: abre o modal com as instruções Safari.
 */
export default function MobileInstallBanner() {
  const { isInstallable, isInstalled, wasDismissed, install, dismiss } = usePWA();
  const [closed, setClosed] = useState(false);

  // Não mostrar se: já instalado, já dispensado, não installable, ou fechado nesta sessão
  if (isInstalled || wasDismissed || !isInstallable || closed) return null;

  const handleClose = () => {
    setClosed(true);
    dismiss();
  };

  return (
    <div
      className="md:hidden bg-[#0b1e44] text-white px-4 py-2.5 flex items-center gap-3"
      data-testid="mobile-install-banner"
      style={{ animation: 'banner-drop 0.3s ease-out' }}
    >
      <style>{`
        @keyframes banner-drop {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <Smartphone className="h-4 w-4 text-amber-400 flex-shrink-0" />

      <p className="flex-1 text-xs font-medium leading-tight">
        Tenha a Trabadju no seu telemóvel
      </p>

      <button
        onClick={install}
        data-testid="mobile-banner-install-btn"
        className="flex-shrink-0 bg-amber-400 text-[#0b1e44] text-xs font-bold px-3 py-1.5 rounded-lg whitespace-nowrap hover:bg-amber-300 transition-colors"
      >
        Instalar Grátis
      </button>

      <button
        onClick={handleClose}
        data-testid="mobile-banner-close"
        className="flex-shrink-0 p-1 hover:bg-white/10 rounded-md transition-colors"
        aria-label="Fechar"
      >
        <X className="h-3.5 w-3.5 text-white/60" />
      </button>
    </div>
  );
}
